/* Maison Byōbu · langage de mouvement « le paravent qui s'ouvre »
   Chaque élément s'anime une seule fois, à sa première apparition. Uniquement transform et opacity.
   La classe mb-js est posée en tête de page par snippets/mb-tete.liquid, jamais si
   prefers-reduced-motion : dans ce cas ce fichier ne fait que la barre discrète. */
(() => {
  window.mbMouvementPret = true;
  const d = document;
  const racine = d.documentElement;
  const anime = racine.classList.contains('mb-js');

  /* Décalage des blocs frères qui apparaissent ensemble */
  d.querySelectorAll('[data-mb-groupe]').forEach((groupe) => {
    groupe.querySelectorAll('[data-mb-apparait]').forEach((el, i) => el.style.setProperty('--mb-i', String(i)));
  });

  /* Panneaux : ordre de lecture d'un byōbu, de droite à gauche */
  d.querySelectorAll('.mb-panneaux').forEach((p) => {
    const sens = p.dataset.sens || 'rtl';
    [...p.children].forEach((b, i) => {
      const k = sens === 'rtl' ? p.children.length - 1 - i : i;
      b.style.setProperty('--d', `${k * 70}ms`);
    });
  });

  if (anime && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entrees) => {
        for (const e of entrees) {
          if (!e.isIntersecting) continue;
          e.target.classList.add('mb-vu');
          io.unobserve(e.target);
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );
    d.querySelectorAll('[data-mb-apparait],[data-mb-masque],[data-mb-trace],[data-mb-panneaux],[data-mb-sceau]').forEach((el) => {
      if (el.querySelector(':scope > .mb-panneaux--rapide')) { el.classList.add('mb-vu'); return; }
      /* Déjà dans le premier écran : on dévoile aussitôt (après une image, pour que le geste se voie) */
      const r = el.getBoundingClientRect();
      if (r.top < innerHeight && r.bottom > 0) {
        requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('mb-vu')));
        return;
      }
      io.observe(el);
    });
  } else {
    d.querySelectorAll('[data-mb-apparait],[data-mb-masque],[data-mb-trace],[data-mb-panneaux],[data-mb-sceau]').forEach((el) => el.classList.add('mb-vu'));
  }

  /* Fondu à l’arrivée des images (opacity seulement) */
  d.querySelectorAll('img.mb-img').forEach((img) => {
    const pret = () => img.classList.add('mb-charge');
    if (img.complete && img.naturalWidth) pret();
    else { img.addEventListener('load', pret, { once: true }); img.addEventListener('error', pret, { once: true }); }
  });

  /* La salle du cadreur : passage du blanc au sombre, retour au blanc à la sortie */
  d.querySelectorAll('[data-mb-salle]').forEach((salle) => {
    if (!anime) { salle.classList.add('mb-dans'); return; }
    new IntersectionObserver(([e]) => salle.classList.toggle('mb-dans', e.isIntersecting), {
      rootMargin: '-28% 0px -28% 0px',
    }).observe(salle);
  });

  /* Dérive lente des grandes images, ordinateur et pointeur fin seulement */
  const derives = [...d.querySelectorAll('[data-mb-derive] img')];
  if (anime && derives.length && matchMedia('(min-width: 1024px) and (pointer: fine)').matches) {
    let enCours = false;
    const maj = () => {
      enCours = false;
      const h = innerHeight;
      for (const img of derives) {
        const r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > h) continue;
        const p = Math.min(Math.max((h - r.top) / (h + r.height), 0), 1);
        img.style.transform = `scale(${(1 + 0.04 * p).toFixed(4)})`;
      }
    };
    /* Sur ordinateur, Horizon fait défiler .page-wrapper et non la fenêtre : on écoute toute la page */
    document.addEventListener('scroll', () => { if (!enCours) { enCours = true; requestAnimationFrame(maj); } }, { passive: true, capture: true });
    maj();
  }

  /* Barre discrète : visible après le seuil, jamais dans la salle */
  const barre = d.querySelector('[data-mb-barre]');
  const seuil = d.querySelector('[data-mb-seuil]');
  const salle = d.querySelector('[data-mb-salle]');
  if (barre && seuil && salle && 'IntersectionObserver' in window) {
    let passe = false;
    let dedans = false;
    const maj = () => {
      const visible = passe && !dedans;
      barre.classList.toggle('mb-visible', visible);
      barre.inert = !visible;
    };
    new IntersectionObserver(([e]) => { passe = !e.isIntersecting && e.boundingClientRect.top < 0; maj(); }).observe(seuil);
    new IntersectionObserver(([e]) => { dedans = e.isIntersecting; maj(); }).observe(salle);
    barre.inert = true;
  }

  /* La barre au prix vivant (04/10) : « À partir de » tant que le mur est l'exemple, puis votre mur et son prix, repris tels
     quels du cadreur (événement mb-cadreur:prix : textes de [data-mb-phrase] et [data-mb-prix], aucun calcul ici). */
  const quoi = barre && barre.querySelector('[data-mb-barre-quoi]');
  const combien = barre && barre.querySelector('[data-mb-barre-prix]');
  const bouton = barre && barre.querySelector('[data-mb-barre-bouton]');
  if (quoi && combien && bouton) {
    const depart = { quoi: quoi.textContent, combien: combien.textContent, bouton: bouton.textContent };
    const ecrire = (el, t) => { if (el.textContent !== t) el.textContent = t; };
    d.addEventListener('mb-cadreur:prix', (e) => {
      const { phrase, prix, exemple } = e.detail || {};
      const vivant = !exemple && phrase && prix && prix !== '—';
      ecrire(quoi, vivant ? phrase : depart.quoi);
      ecrire(combien, vivant ? prix : depart.combien);
      ecrire(bouton, vivant ? 'Revenir à mon mur' : depart.bouton);
    });
  }

  /* La première exposition : l'image suit l'œuvre survolée */
  d.querySelectorAll('[data-mb-expo]').forEach((expo) => {
    const images = [...expo.querySelectorAll('[data-mb-expo-image]')];
    const phrase = expo.querySelector('[data-mb-expo-phrase]');
    if (!images.length) return;
    let actif = images[0].dataset.mbExpoImage;
    const montrer = (cle) => {
      if (!cle || cle === actif) return;
      actif = cle;
      images.forEach((img) => img.classList.toggle('mb-actif', img.dataset.mbExpoImage === cle));
      if (phrase) {
        const ligne = expo.querySelector(`[data-mb-expo-ligne="${cle}"]`);
        phrase.classList.add('mb-change');
        setTimeout(() => { phrase.textContent = ligne ? ligne.dataset.phrase : ''; phrase.classList.remove('mb-change'); }, 220);
      }
    };
    expo.querySelectorAll('[data-mb-expo-ligne]').forEach((ligne) => {
      const cle = ligne.dataset.mbExpoLigne;
      ligne.addEventListener('pointerenter', () => montrer(cle));
      ligne.addEventListener('focusin', () => montrer(cle));
    });
  });

  /* Panneaux latéraux (guide de mesure) */
  d.addEventListener('click', (e) => {
    const ouvrir = e.target.closest('[data-mb-ouvrir]');
    if (ouvrir) {
      const panneau = d.querySelector(`[data-mb-panneau="${ouvrir.dataset.mbOuvrir}"]`);
      if (panneau && typeof panneau.showModal === 'function') { e.preventDefault(); panneau.showModal(); }
      return;
    }
    const fermer = e.target.closest('[data-mb-fermer]');
    if (fermer) fermer.closest('dialog')?.close();
    if (e.target.matches('dialog.mb-panneau')) e.target.close();
  });

  /* Le repère des pages longues : visible hors du premier écran, il nomme le chapitre en cours
     et ramène au début (le menu et les boutons). Aussi quand les animations sont réduites. */
  const repere = d.querySelector('[data-mb-repere]');
  if (repere) {
    const lieu = repere.querySelector('[data-mb-repere-lieu]');
    const defileur = () => {
      const w = d.querySelector('.page-wrapper');
      return w && w.scrollHeight > w.clientHeight + 1 && getComputedStyle(w).overflowY !== 'visible' ? w : d.scrollingElement;
    };
    repere.hidden = false;
    let prevu = false;
    const maj = () => { prevu = false; repere.classList.toggle('mb-repere--visible', defileur().scrollTop > innerHeight * 0.9); };
    d.addEventListener('scroll', () => { if (!prevu) { prevu = true; requestAnimationFrame(maj); } }, { passive: true, capture: true });
    maj();
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entrees) => {
        entrees.forEach((e) => { if (e.isIntersecting && lieu) lieu.textContent = e.target.dataset.mbChapitre; });
      }, { rootMargin: '-49% 0px -50% 0px' });
      d.querySelectorAll('[data-mb-chapitre]').forEach((el) => io.observe(el));
    }
    repere.addEventListener('click', (e) => {
      e.preventDefault();
      const reduit = matchMedia('(prefers-reduced-motion: reduce)').matches;
      defileur().scrollTo({ top: 0, behavior: reduit ? 'auto' : 'smooth' });
      repere.blur();
    });
  }

  /* Sommaire des pages longues : la partie en cours de lecture s'éclaire (repère, pas une animation) */
  const ancres = [...d.querySelectorAll('.mb-texte__ancre')];
  if (ancres.length && 'IntersectionObserver' in window) {
    const lien = new Map();
    ancres.forEach((a) => {
      const cible = d.getElementById(decodeURIComponent(a.hash.slice(1)));
      if (cible) lien.set(cible, a);
    });
    const visibles = new Set();
    const marquer = () => {
      const premier = [...lien.keys()].find((t) => visibles.has(t));
      if (!premier) return;
      ancres.forEach((a) => a.removeAttribute('aria-current'));
      lien.get(premier).setAttribute('aria-current', 'true');
    };
    const obs = new IntersectionObserver((entrees) => {
      entrees.forEach((e) => (e.isIntersecting ? visibles.add(e.target) : visibles.delete(e.target)));
      marquer();
    }, { rootMargin: '-10% 0px -55% 0px' });
    lien.forEach((_a, t) => obs.observe(t));
  }
})();
